import React from "react";
import urlRegex from "url-regex";
import { styled } from "../stitches.config";
import { AnyBlock, LinkBlock as LinkBlockType, Point2D } from "../types";
import { clampPosition, pixelToGridPosition } from "../utils/gridPosition";
import createBlock from "./createBlock";
import { Bezel } from "./CssBlock";

export function LinkBlock({
  block,
  updateBlock,
}: {
  block: LinkBlockType;
  updateBlock: (block: AnyBlock) => void;
}) {
  return (
    <Bezel>
      <Link target="_blank" href={block.value}>
        {block.value}
      </Link>
    </Bezel>
  );
}

const Link = styled("a", {
  wordBreak: "break-all",
  fontSize: "$5",
});

export function handleTextPaste(
  dataTransfer: DataTransfer | null,
  upsertBlock: (b: AnyBlock) => void,
  mousePosition: Point2D
) {
  const items = dataTransfer?.items;
  if (!items) return;
  for (let i = 0; i < items.length; i++) {
    const item = items[i];
    if (!item.type.includes("text/plain")) continue;
    item.getAsString((string: string) => {
      if (string.match(urlRegex({ exact: true }))) {
        const block = createBlock(
          "link",
          clampPosition(
            pixelToGridPosition({
              x: mousePosition.x,
              y: mousePosition.y,
            })
          ),
          {
            width: 10,
            height: 4,
          }
        );
        if (block) upsertBlock({ ...block, value: string });
      }
    });
  }
}
